import { drugsRouteStore } from '../domain/store';

export default (e) => {
  if (e) {
    drugsRouteStore.setValue('activeDrugId', e.content.id);
  }

  drugsRouteStore.setValue('showingDrugUpsertModal', true);
};
